<template>
  <UIButton
    v-bind="{ size }"
    :leading="XMarkIcon"
    :label="buttonLabel"
    variant="gray"
    fill="outlined"
    hide-label-to-sm
  />
</template>

<script setup lang="ts">
import { computed, inject } from 'vue'

import { ButtonSize } from '@types'

import { XMarkIcon } from '@heroicons/vue/24/outline'

import { UIButton } from '@ui/buttons'

type Props = {
  selectedCount?: number
}

const { selectedCount } = defineProps<Props>()

const size = inject<ButtonSize>('size')

const buttonLabel = computed(() => {
  if (selectedCount && selectedCount > 0) {
    return `Cancel (${selectedCount})`
  }
  return 'Cancel all'
})
</script>
